import { render, staticRenderFns } from "./memberprofile.vue?vue&type=template&id=8dac37b6&scoped=true&"
import script from "./memberprofile.vue?vue&type=script&lang=js&"
export * from "./memberprofile.vue?vue&type=script&lang=js&"
import style0 from "./memberprofile.vue?vue&type=style&index=0&id=8dac37b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dac37b6",
  null
  
)

export default component.exports